export enum ChangePhotoEnum {
    Upload = "upload",
    Delete = "delete",
    Get = "get"
}
